<app-container class="auth-container" [noPadding]="handsetService.isXs" fxLayoutAlign="center" maxWidth="516px"
               ngClass.xs="xs">


  <mat-card class="card" fxLayout="column" ngClass.xs="xs">
    <mat-card-header class="header-with-big-space" fxLayout="column" fxLayoutAlign="center center">
      <a class="logo" href="https://payka.pl/">
        <img src="/assets/images/logo-payka/logo_payka.svg" alt="payka.pl" />
      </a>
      <h1>
        Witaj w Panelu Payka
      </h1>
      <p>
        Zaloguj się
      </p>
    </mat-card-header>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-card-content>
        <div ngClass.xs="xs" fxFlex.xs class="container-content">
          <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="16px">
            <div fxLayout="column" fxLayoutGap="12px">
              <mat-form-field appearance="outline" class="login-form-field" [hideRequiredMarker]="true">
                <mat-label>Adres e-mail</mat-label>
                <input
                  matInput
                  id="email"
                  class="clean-autofill"
                  type="email"
                  [formControl]="form.email"
                  name="email"
                  required
                  autocomplete="username"
                  appGtmFormEvent
                  [eventField]="'username'"
                  [eventForm]="formName"
                />
                <mat-error *ngIf="form.email.errors?.required"> Wpisz adres e-mail</mat-error>
                <mat-error *ngIf="form.email.errors?.invalidEmail"> Wpisz prawidłowy adres e-mail</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="password-form-field" [hideRequiredMarker]="true">
                <mat-label>Hasło</mat-label>
                <input
                  matInput
                  id="password"
                  class="clean-autofill"
                  [type]="passwordVisible ? 'text' : 'password'"
                  data-ls-disabled
                  [formControl]="form.password"
                  name="password"
                  required
                  autocomplete="current-password"
                  appGtmFormEvent
                  [eventField]="'password'"
                  (keydown.enter)="onSubmit()"
                  [eventForm]="formName" />

                <button
                  matSuffix
                  mat-icon-button
                  type="button"
                  aria-label="pokaż-hasło"
                  style="height: 44px"
                  class="password-visibility-btn"
                  [matTooltip]="passwordVisible ? 'Ukryj hasło' : 'Pokaż hasło'"
                  (click)="passwordVisible = !passwordVisible">
                  <app-icon
                    [name]="passwordVisible ? 'visibility_off_filled' : 'visibility_filled'"
                    color="rgba(0,0,0,.5)"
                    size="20"
                    matSuffix
                  ></app-icon>
                </button>
                <mat-error *ngIf="form.password.errors?.required"> Wpisz hasło</mat-error>

                <mat-error *ngIf="form.password.errors?.invalidCredentials">
                  Nieprawidłowy email lub hasło
                </mat-error>
                <mat-error *ngIf="form.password.errors?.tooManyRequests">
                  Zbyt dużo prób logowania - spróbuj ponownie za jakiś czas
                </mat-error>
              </mat-form-field>
              <div class="text-center" *ngIf="registerTotp ">
                <mat-label>Konfiguracja OTP</mat-label>
                <app-loading [loading]="imgLoader" [local]="true" fxLayout="column"
                             fxLayoutAlign="center center"></app-loading>
                <ng-container *ngIf="qrUrl">
                  <img style="width: 200px; height: 200px" [src]="qrUrl" alt="QR do konfiguracji TOTP" />
                  <p>Zeskanuj w Microsoft Authenticator / Google Authenticator. A następnie wprowadź kod z aplikacji i
                    przejdź dalej. </p>
                </ng-container>
              </div>

              <mat-form-field *ngIf="showTotp" appearance="outline" class="login-form-field"
                              [hideRequiredMarker]="true">
                <mat-label>Kod</mat-label>
                <input
                  [formControl]="form.totp"
                  name="totp" inputmode="numeric" pattern="[0-9]*"
                  maxlength="6"
                  matInput
                  id="totp"

                  class="clean-autofill"
                  type="email"
                  required
                  appGtmFormEvent
                  [eventField]="'totp'"
                  [eventForm]="formName"
                />

                <mat-error *ngIf="form.totp.errors?.required"> Wpisz kod</mat-error>

              </mat-form-field>
              <div class="under-password">
                <div *ngIf="false" fxFlex class="consent-text-all h3-regular">
                  <mat-checkbox formControlName="rememberMe">Zapamiętaj to urządzenie
                  </mat-checkbox>
                </div>
                <div>
                  <a [queryParams]="getQueryParams()" routerLink="/auth/resetPassword/sendEmail"
                     class="h3-regular">Nie pamiętam hasła</a>
                </div>
              </div>
            </div>

            <mat-error *ngFor="let error of errors">
              {{ errorMessages[error] }}
            </mat-error>

            <div class="actions-login" fxLayout="column" fxLayoutAlign="start center">
              <app-new-loader-button
                [disabled]="(submitted && !form.valid) || imgLoader"
                (buttonClick)="onSubmit()"
                [loading]="loading"
                [customType]="LoaderButtonType.RAISED"
                class="auth-button"
                id="login-button"
                color="accent">
                Zaloguj się
              </app-new-loader-button>

            </div>
            <footer fxLayout="row" class="footer">
              <p class="h3-regular">
                Nie masz konta?
                <a class="h3-regular" [routerLink]="['/auth/register']"
                   [queryParams]="getQueryParams()">Zarejestruj się</a>
              </p>
            </footer>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions fxLayout="column" class="flex"
                        style="align-self: center; ">
        <ng-content select="[buttons]"></ng-content>
      </mat-card-actions>
      <mat-card-footer>
        <div class="lock" fxLayout="column" fxLayoutAlign="center center">
          <img src="/assets/images/icons/lock.svg" alt="Bezpieczne logowanie" />
        </div>
      </mat-card-footer>
    </form>
  </mat-card>
</app-container>


